import React from 'react'
import styled, { keyframes, css } from "styled-components";

const row1 = [
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/7ae42bac3b34999c0db3.png",
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/b2bd91d7b87b2181ca45.png",
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/6591cdc0702b32310306.png",
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/3b7d9f4b073deb6a9b74.png",
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/3cd767dea94a85078ca4.png",
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/a2b3c3709ffedce2a22a.png",
    "https://cdn.worldvectorlogo.com/logos/infosys-3.svg",
    "https://cdn.worldvectorlogo.com/logos/wipro-1.svg",
    "https://images.seeklogo.com/logo-png/30/2/tech-mahindra-logo-png_seeklogo-304147.png",
    "https://cdn.worldvectorlogo.com/logos/capgemini-201x-logo.svg",
    "https://cdn.worldvectorlogo.com/logos/oracle-6.svg",
    "https://cdn.worldvectorlogo.com/logos/zoho-1.svg",
    "https://cdn.worldvectorlogo.com/logos/ey.svg",
    "https://cdn.worldvectorlogo.com/logos/flipkart.svg",
    "https://cdn.worldvectorlogo.com/logos/paytm-1.svg", 
    "https://cdn.worldvectorlogo.com/logos/deloitte-1.svg",
    "https://images.seeklogo.com/logo-png/43/2/blinkit-logo-png_seeklogo-438944.png",
    "https://cdn.worldvectorlogo.com/logos/samsung-8.svg",
    "https://cdn.worldvectorlogo.com/logos/salesforce-2.svg",  
  ];

  const row2 = [
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/6c585c33ca6c71c79bb7.png",
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/9dd55e54b5a28658bf4e.png",
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/0384060dcbf73b6a707c.png",
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/35e044b3354aaa0caed5.png",
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/f50ae7cbf6cc805bdadc.png",
    "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/6c585c33ca6c71c79bb7.png",
    "https://cdn.worldvectorlogo.com/logos/tata-consultancy-services-1.svg",
    "https://cdn.worldvectorlogo.com/logos/hcltech-1.svg",
    "https://cdn.worldvectorlogo.com/logos/cognizant-1.svg",
    "https://cdn.worldvectorlogo.com/logos/ibm.svg",
    "https://cdn.worldvectorlogo.com/logos/swiggy-logo.svg",
    "https://cdn.worldvectorlogo.com/logos/accenture-6.svg",
    "https://cdn.worldvectorlogo.com/logos/google-pay-2.svg",
    "https://cdn.worldvectorlogo.com/logos/zomato-1.svg",
    "https://cdn.worldvectorlogo.com/logos/spotify-logo.svg",
    "https://cdn.worldvectorlogo.com/logos/uber-2.svg",
    "https://cdn.worldvectorlogo.com/logos/meta-3.svg",
    
  ];

function Mobile_view_brand() {
  return (
    <div>
    <div className="overflow-hidden">
    <AppContainer>
      <Wrapper>
        <Marquee>
          <MarqueeGroup>
            {row1.map((el) => (
              <ImageGroup>
                <Image src={el} />
              </ImageGroup>
            ))}
          </MarqueeGroup>
          <MarqueeGroup>
            {row1.map((el) => (
              <ImageGroup>
                <Image src={el} />
              </ImageGroup>
            ))}
          </MarqueeGroup>
        </Marquee>
        <Marquee>
          <MarqueeGroup2>
            {row2.map((el) => (
              <ImageGroup>
                <Image src={el} />
              </ImageGroup>
            ))}
          </MarqueeGroup2>
          <MarqueeGroup2>
            {row2.map((el) => (
              <ImageGroup>
                <Image src={el}  />
              </ImageGroup>
            ))}
          </MarqueeGroup2>
        </Marquee>
      </Wrapper>
    </AppContainer>
    </div>
    </div>
  )
}

export default Mobile_view_brand



const AppContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Marquee = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  user-select: none;

  mask-image: linear-gradient(
    to right,
    hsl(0 0% 0% / 0),
    hsl(0 0% 0% / 1) 10%,
    hsl(0 0% 0% / 1) 90%,
    hsl(0 0% 0% / 0)
  );
`;
// const Marquee = styled.div`
//   display: flex;
//   width: 1200px;
//   overflow: hidden;
//   user-select: none;

//   mask-image: linear-gradient(
//     to right,
//     hsl(0 0% 0% / 0),
//     hsl(0 0% 0% / 1) 10%,
//     hsl(0 0% 0% / 1) 90%,
//     hsl(0 0% 0% / 0)
//   );
// `;

const scrollX = keyframes`
  from {
    left: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;

// const common = css`
//   flex-shrink: 0;
//   display: flex;
//   align-items: center;
//   justify-content: space-around;
//   white-space: nowrap;
//   width: 100%;
//   animation: ${scrollX} 30s linear infinite;
// `;
const common = css`
  display: flex;
  align-items: center;
  gap: 20px;             
  flex-shrink: 0;        
  white-space: nowrap;
  animation: ${scrollX} 50s linear infinite;
`;

const MarqueeGroup = styled.div`
  ${common}
`;
const MarqueeGroup2 = styled.div`
  ${common}
  animation-direction: reverse;
  animation-delay: -3s;
`;

// const ImageGroup = styled.div`
//   display: grid;
//   place-items: center;
//   width: clamp(10rem, 1rem + 40vmin, 30rem);
//   padding: calc(clamp(10rem, 1rem + 30vmin, 30rem) / 10);
// `;

// const Image = styled.img`
//   object-fit: contain;
//   width: 100%;
//   height: 100%;
//   /* border: 1px solid black; */
//   border-radius: 0.5rem;
//   aspect-ratio: 16/9;
//   padding: 5px 20px;
//   box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
// `;

const ImageGroup = styled.div`
  display: grid;
  place-items: center; 
  width: 170px;    
  height: 110px;   
  padding: calc(clamp(10rem, 1rem + 30vmin, 30rem) / 10);  
  flex-shrink: 0;  
`;

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  /* border: 1px solid black; */
  border-radius: 0.5rem;
  aspect-ratio: 16/9;
  padding: 5px 20px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;


